import MenuItems from "../components/StartMenu/MenuItems";

function StartMenu() {
    return (
        <div>
            <h1 style={{ textAlign: "center" }}>Onitama</h1>
            <MenuItems />
        </div>
    );
}

export default StartMenu;
